import clsx from 'clsx';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { PropsWithChildren, useState } from 'react';

interface StyledFormSectionProps {
  sectionTitle: string;
  shouldTakeHalfWidth?: boolean;
  shouldTakeFullWidth?: boolean;
  isExpandable?: boolean;
  icon?: React.ReactNode;
  /** Replaces the default width classes of the content column. */
  contentWidthClassName?: string;
}

const StyledFormSection = ({
  sectionTitle,
  shouldTakeHalfWidth = false,
  shouldTakeFullWidth = false,
  isExpandable = false,
  icon,
  contentWidthClassName,
  children,
}: PropsWithChildren<StyledFormSectionProps>) => {
  const [isReduced, setIsReduced] = useState(false);

  return (
    <div className="flex flex-col md:flex-row gap-6 p-6 relative">
      <div className="flex flex-row items-start gap-2 md:w-1/4">
        <h2 className="text-base font-medium text-black">{sectionTitle}</h2>
        {icon}
      </div>
      {!isReduced && (
        <div
          className={clsx(
            'flex flex-col gap-4 w-full ',
            contentWidthClassName ?? {
              'xl:w-full': shouldTakeFullWidth,
              'xl:w-1/2 pr-6': shouldTakeHalfWidth,
              'lg:w-1/2 2xl:w-1/3':
                !shouldTakeHalfWidth && !shouldTakeFullWidth,
            },
          )}
        >
          {children}
        </div>
      )}
      {isExpandable &&
        (isReduced ? (
          <ChevronDownIcon
            className="size-6 absolute top-0 translate-y-full right-4 hover:cursor-pointer"
            onClick={() => {
              setIsReduced((prevIsReduced) => !prevIsReduced);
            }}
          />
        ) : (
          <ChevronUpIcon
            className="size-6 absolute top-0 translate-y-full right-4 hover:cursor-pointer"
            onClick={() => {
              setIsReduced((prevIsReduced) => !prevIsReduced);
            }}
          />
        ))}
    </div>
  );
};

export default StyledFormSection;
